export const LG_LICENSE_KEY = '7EC452A9-0CFD441C-BD984C7C-17C8456E';
